import React, { useRef } from "react";
import PropTypes from "prop-types";
import TextInput from "./TextInput";
import { Alert } from "reactstrap";
import { Formik, Form, Field } from "formik";
import { faPlus, faEdit, faTimes } from "@fortawesome/fontawesome-free-solid";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import Button from "./CustomButton";
import { getBreakpointFromWidth } from "../helpers/index";
import SelectInput from "./SelectInput";
import _ from "lodash";
import * as Yup from "yup";
import { compose, setDisplayName } from "recompose";
import NextForm from "../containers/NextForm";

const propTypes = {
  submittingDiscount: PropTypes.bool.isRequired,
  failSubmitDiscount: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  clearDiscount: PropTypes.func.isRequired,
  initialValues: PropTypes.object
};

const validationSchema = Yup.object().shape({
  description: Yup.string().required("Required"),
  discount_type: Yup.string().required("Required"),
  quantity: Yup.number().when("discount_type", {
    is: "percent",
    then: Yup.number()
      .min(1, "at least 1%")
      .max(100, "at most 100%")
      .required("Required")
      .typeError("Invalid number"),
    otherwise: Yup.number()
      .min(1, "Invalid quantity")
      .required("Required")
      .typeError("Invalid number")
  })
});

const source = [
  {
    value: "flat",
    label: "Flat Fee"
  },
  {
    value: "percent",
    label: "Percentage"
  }
];

const DiscountForm = compose(
  setDisplayName("DiscountForm"),
  NextForm
)(
  ({
    onSubmit,
    initialValues,
    submittingDiscount,
    failSubmitDiscount,
    currentDiscount,
    clearDiscount,
    focusNextField,
    setInputRef
  }) => {
    const divRef = useRef(null);
    const breakpoint = getBreakpointFromWidth(
      _.get(divRef, "current.clientWidth", window.innerWidth)
    );
    return (
      <div ref={divRef}>
        <Formik
          enableReinitialize
          onSubmit={onSubmit}
          validationSchema={validationSchema}
          initialValues={initialValues}
          render={({ submitForm, setTouched, setErrors }) => {
            return (
              <Form>
                {failSubmitDiscount && (
                  <Alert color="danger">{failSubmitDiscount}</Alert>
                )}
                <div className="row">
                  <div className={breakpoint === "xs" ? "col-12" : `col pl-1`}>
                    <Field
                      name="discount_type"
                      source={source}
                      component={SelectInput}
                      placeholder="Discount Type"
                    />
                  </div>
                  <div className={breakpoint === "xs" ? "col-12" : `col px-1`}>
                    <Field
                      innerRef={setInputRef("description")}
                      onKeyPress={focusNextField("quantity")}
                      name="description"
                      component={TextInput}
                      placeholder="Description"
                    />
                  </div>
                  <div className={breakpoint === "xs" ? "col-12" : `col pr-1`}>
                    <Field
                      innerRef={setInputRef("quantity")}
                      onKeyPress={e => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                          submitForm();
                          /*  setTimeout(() => {
                            setTouched({
                              quantity: false,
                              discount_type: false,
                              description: false
                            });
                            setErrors({
                              quantity: null,
                              discount_type: null,
                              description: null
                            });
                          }, 200); */
                        }
                      }}
                      name="quantity"
                      component={TextInput}
                      placeholder="Amount"
                    />
                  </div>
                  
                </div>
                <div className="row">
                  <div
                    className={`${
                      breakpoint === "xs" ? "col-12" : "col-auto pr-1"
                    } mb-3`}
                  >
                    <Button
                      fill
                      block
                      type="button"
                      onClick={submitForm}
                      disabled={submittingDiscount}
                      color="info"
                    >
                      {`${currentDiscount ? "Update" : "Add"} Discount `}
                      <FontAwesomeIcon
                        icon={currentDiscount ? faEdit : faPlus}
                      />
                    </Button>
                  </div>
                  {currentDiscount && (
                    <div
                      className={`${
                        breakpoint === "xs" ? "col-12" : "col-auto pl-1"
                      } mb-3`}
                    >
                      <Button
                        block
                        type="button"
                        onClick={clearDiscount}
                        color="info"
                      >
                        Cancel <FontAwesomeIcon icon={faTimes} />
                      </Button>
                    </div>
                  )}
                </div>
              </Form>
            );
          }}
        />
      </div>
    );
  }
);

DiscountForm.propTypes = propTypes;

export default DiscountForm;
